module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "confirmation-modal",
    attrs: {
      "width": "600px",
      "height": "100px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.textTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body file-download-modal-body",
    staticStyle: {
      "height": "150px",
      "padding": "5px 15px",
      "overflow-x": "auto"
    }
  }, [_c('center', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.textMessage)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.spinVisable),
      expression: "spinVisable"
    }],
    staticClass: "glyphicon glyphicon-repeat glyphicon-spin",
    staticStyle: {
      "font-size": "30px",
      "color": "#5b9bd5"
    }
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "open_file",
    attrs: {
      "href": _vm.linkToOpen,
      "target": 'open_file' + _vm.linkToOpen
    }
  }, [_vm._v("#")])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5240dc0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/file-download-modal.vue
// module id = 1073
// module chunks = 0